import {LinkOption} from './hooks/useLinkOptions';

interface MenuItem {
    key: string;
    text?: string;
    title?: string;
    onClick?: () => void;
    list?: {
        title?: string;
        arr: Array<{
            key: string;
            title: string;
            leftChildren?: string;
            onClick: () => void;
        }>;
    };
}

interface MenuList {
    arr: MenuItem[];
}

interface BuildMenuListParams {
    allOptions: LinkOption[];
    handleSelect: (path: string) => void;
    handleCustomSelect: () => void;
    t: (key: string) => string;
    layoutT: (key: string) => string;
}

export function buildMenuList({
    allOptions,
    handleSelect,
    handleCustomSelect,
    t,
    layoutT
}: BuildMenuListParams): MenuList {
    return {
        arr: [
            {
                key: 'account',
                text: t('accountLevel'),
                list: {
                    title: t('accountLevel'),
                    arr: allOptions
                        .filter(o => o.group === 'account')
                        .map(o => ({
                            key: o.key,
                            title: o.label,
                            onClick: () => handleSelect(o.path)
                        }))
                }
            },
            {
                key: 'event',
                text: t('eventLevel'),
                list: {
                    title: t('eventLevel'),
                    arr: allOptions
                        .filter(o => o.group === 'event')
                        .map(o => ({
                            key: o.key,
                            title: o.label,
                            leftChildren: o.label,
                            onClick: () => handleSelect(o.path)
                        }))
                }
            },
            {
                key: 'support',
                title: layoutT('support'),
                onClick: () => handleSelect('/support')
            },
            {
                key: 'custom',
                title: layoutT('custom'),
                onClick: handleCustomSelect
            }
        ]
    };
}
